import type { Statement } from '../internal/types';

export function filterAllowStatements(statements: Statement[]) {
  return statements.filter((statement) => !!statement.resources && statement.effect === 'allow');
}
